import React from 'react';
import {
  Chart,
  LineElement, BarElement, PointElement,
  LinearScale, CategoryScale, LogarithmicScale,
  Tooltip, Legend, Filler,
  LineController, BarController,
} from 'chart.js';

Chart.register(
  LineElement, BarElement, PointElement,
  LinearScale, CategoryScale, LogarithmicScale,
  Tooltip, Legend, Filler,
  LineController, BarController,
);
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { loadConfig } from './lib/config';
import './index.css';

// Load runtime config (config.json in deployed envs, Vite env vars locally)
// before rendering so that api.ts and auth.ts have access to resolved values.
loadConfig().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  );
});